import React from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Tooltip from 'chameleon/ui-stack/ui/base/tooltip';
import { toast } from 'chameleon/ui-stack/ui/toast';

const ShareLink = (props) => {
  const {
    children,
    notificationText,
    onCopy: onCopyCallback,
    text,
    timeout,
    tooltip,
  } = props;

  const onCopy = () => {
    toast(notificationText, {
      timeout,
    });
    onCopyCallback && onCopyCallback();
  };

  const content = (
    <CopyToClipboard
      text={text}
      onCopy={onCopy}
      options={{ format: 'text/plain' }}
    >
      {children}
    </CopyToClipboard>
  );

  if (tooltip) {
    return <Tooltip {...tooltip}>{content}</Tooltip>;
  }

  return content;
};

ShareLink.propTypes = {
  children: PropTypes.node.isRequired,
  notificationText: PropTypes.string,
  onCopy: PropTypes.func,
  text: PropTypes.string.isRequired,
  timeout: PropTypes.number,
  tooltip: PropTypes.object,
};

ShareLink.defaultProps = {
  notificationText: 'Link has been copied to clipboard',
  onCopy: null,
  timeout: 3,
  tooltip: null,
};

export default ShareLink;
